/**
 * This is the ErrorPage module configuration.
 * Do NOT configure routes in this file.
 * @memberOf ErrorPage Module
 * @namespace ErrorPage Config
 */

/**
 * @name config
 * @desc Configures the module.
 * @memberOf ErrorPage Module.ErrorPage Config
 * @ngInject
 */
var config = function () {
}

export default config;


// WEBPACK FOOTER //
// ./src/errorpage/errorpage.config.js